/**
 * Contact tag class
 */
export default class {
  constructor (data) {
    this.id = ~~data.id
    this.name = data.name
    this.inUseCount = data.in_use_count || 0
    this.isPersonal = false
  }
}
